"use strict";

var _Landing_FmoHomeViewer, _Text;
import { Avatar } from '@autoguru/avatar';
import { ContainedLayout } from '@autoguru/layout';
import { Box, Stack, Text } from '@autoguru/overdrive';
import { ViewerFleetCompaniesAsManagerList } from '@autoguru/viewer-fleet-company-select';
import { graphql } from 'react-relay';
import { useFragment } from 'react-relay/hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Landing = ({
  viewer: viewerRef
}) => {
  const {
    avatarUrl,
    firstName,
    fleetCompaniesAsManager
  } = useFragment(_Landing_FmoHomeViewer !== void 0 ? _Landing_FmoHomeViewer : (_Landing_FmoHomeViewer = require("../../../../../packages/relay/__generated__/Landing_FmoHomeViewer.graphql"), _Landing_FmoHomeViewer.hash && _Landing_FmoHomeViewer.hash !== "3f82534f0eb08c1238b41114f3a4e437" && console.error("The definition of 'Landing_FmoHomeViewer' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _Landing_FmoHomeViewer), viewerRef);
  return /*#__PURE__*/_jsx(ContainedLayout, {
    children: /*#__PURE__*/_jsxs(Stack, {
      space: "6",
      children: [/*#__PURE__*/_jsxs(Box, {
        width: "full",
        height: "full",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingX: "6",
        paddingY: "4",
        children: [/*#__PURE__*/_jsx(Box, {
          marginBottom: "6",
          children: /*#__PURE__*/_jsx(Avatar, {
            size: 150,
            src: avatarUrl,
            altText: firstName
          })
        }), /*#__PURE__*/_jsxs(Text, {
          strong: true,
          align: "center",
          size: "4",
          children: ["Welcome back ", firstName]
        }), _Text || (_Text = /*#__PURE__*/_jsx(Text, {
          align: "center",
          children: "Select a Fleet Company"
        }))]
      }), /*#__PURE__*/_jsx(ViewerFleetCompaniesAsManagerList, {
        fleetCompanies: fleetCompaniesAsManager.edges
      })]
    })
  });
};